var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenV(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.993 11.319L15.3166 2.00991C15.5597 1.76724 15.5613 1.37219 15.3202 1.12754L14.8836 0.684501C14.6425 0.439852 14.25 0.438328 14.0069 0.680997L5.56348 9.11124L2.00017 5.49573C1.75907 5.25109 1.36652 5.24951 1.12346 5.49218L0.683333 5.93161C0.440266 6.17428 0.438702 6.56934 0.679801 6.81399L5.11629 11.3155C5.35739 11.5601 5.74994 11.5617 5.993 11.319Z",
    fill: "#20662E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenV);
export default __webpack_public_path__ + "static/media/GreenV.a8dc6a77ed15edf7bf1372d2fe4ba910.svg";
export { ForwardRef as ReactComponent };